module.exports = __webpack_public_path__ + "img/move20.94eae74f.jpg";